import MoneyInput from './money-input';

export default MoneyInput;
